import {   GET_REPORT_IP_REQUEST, GET_REPORT_IP_SUCCESS, GET_REPORT_IP_ERROR} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_REPORT_IP_REQUEST:
            return {
                loading: true,
            };
        case GET_REPORT_IP_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_REPORT_IP_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}